import { render, staticRenderFns } from "./DownloadOrGoToSOVTable.vue?vue&type=template&id=dde483b0&scoped=true&"
import script from "./DownloadOrGoToSOVTable.vue?vue&type=script&lang=js&"
export * from "./DownloadOrGoToSOVTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde483b0",
  null
  
)

export default component.exports